module.exports = __webpack_public_path__ + "static/media/DSC01003-33_Small.42d2bcf1.jpg";